export const VIDEO_URL = `https://www.youtube.com/watch?v=ho29jkyzGyQ`